// extracted by mini-css-extract-plugin
export default {"addToCartControl":"TZ-z","giftCard":"UZ-z","btnContainer":"VZ-z","cartButton":"WZ-z","disabled":"XZ-z"};